import BaseApi from "./baseApi";

class DirectoryApi extends BaseApi {
  async getAllRoastersOfRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/getAllRoastersOfRetreat",
      data: data,
      method: "post",
    });
  }

  async getDirectoryDetail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/getDirectoryDetail",
      data: data,
      method: "post",
    });
  }

  async createDirectory(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/createDirectory",
      data: data,
      method: "post",
    });
  }

  async saveCoupleImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/saveCoupleImage",
      data: data,
      method: "post",
    });
  }

  async removeImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/removeImage",
      data: data,
      method: "post",
    });
  }

  async removeDirectoryImage(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/removeDirectoryImage",
      data: data,
      method: "post",
    });
  }

  async uploadLinks(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/upload-links",
      data: data,
      method: "post",
    });
  }

  async sendDirProgMail(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/directory/send-dir-prog-mail",
      data: data,
      method: "post",
    });
  }
}

export default DirectoryApi;
